import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const FillPhishing = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19 5.67C19 3.64 17.36 2 15.33 2C13.3 2 11.66 3.64 11.66 5.67C11.66 7.25 12.67 8.59 14.08 9.11V16.22C14.08 18.03 12.6 19.51 10.79 19.51C8.98 19.51 7.64 18.15 7.52 16.44H10.81L5 11.34V16.43H5.01C5.13 19.52 7.67 22 10.79 22C13.91 22 16.58 19.4 16.58 16.21V9.1C17.99 8.59 19 7.25 19 5.66V5.67ZM15.33 7.24C14.47 7.24 13.76 6.54 13.76 5.67C13.76 4.8 14.46 4.1 15.33 4.1C16.2 4.1 16.9 4.8 16.9 5.67C16.9 6.54 16.2 7.24 15.33 7.24Z"
      fill="#565B6D"
    />
  </svg>
)

export default withDefaultStyles(FillPhishing)
